import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import _ from "lodash";

export default {
  async getMapsConfig({ commit, state }, { principal, ignorePrincipal } = {}) {
    const headers = getTokenHeader(),
      selectedPrincipal = principal || state.selectedPrincipal?.id;
    if (headers && selectedPrincipal)
      try {
        const config = {
          headers,
          params: {}
        };
        if (ignorePrincipal) config.params.ignorePrincipalId = "1";
        else config.params.currentPrincipal = selectedPrincipal;

        const response = await axios.get(
          `${env.maps_api_client_url}config/${selectedPrincipal}/`,
          config
        );

        commit("SET_MAPS_CONFIG", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getMapsApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(`${env.maps_api_client_url}apiKey/`, {
          params: {
            ...query,
            principal_id: state.selectedPrincipal.id
          },
          headers
        });
        commit("SET_MAPS_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  }
};
